<template>
  <div class="xcar pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">
      ASIGNACIONES DE PROGRAMAS DE LA SEDE. test
    </h4>

    <v-row dense class="ml-2">
      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Seleccione la fecha:"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field v-model.number="xcuota" label="Cuota:" type="number" dense outlined />
      </v-col>
      <v-col cols="12" sm="3" md="4">
        <v-switch
          v-model="only_cuota"
          :label="only_cuota ? 'Mostrar desde cuota seleccionada' : 'Mostrar solo cuota seleccionada'"
          :disabled="loading"
          dense
          hide-details
          title="Mostrar datos de la cuota seleccionada."
          class="mb-4"
        ></v-switch>
      </v-col>
      <v-col cols="2">
        <v-switch
          v-model="omit_filtro"
          label="Mostrar total"
          :disabled="loading"
          dense
          hide-details
          title="Omitir el filtro por convenio y mostrar todo."
          class="mb-4"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="2" md="3">
        <v-btn class="blue darken-2" dark tile :disabled="loading" @click="obtenerasignaciones()">Calcular</v-btn>
      </v-col>
    </v-row>
    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />

    <p class="mb-0" v-if="xname">
      <b>Asignacion de la sede: {{ xname }}</b>
    </p> 
    <!-- <v-tabs v-model="tabmodel" centered slider-color="yellow" >
      <v-tab v-for="i in 3" :key="i" :href="`#tab-${i}`">
        Item {{ i }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabmodel">
      <v-tab-item v-for="i in 3" :key="i" :value="`tab-${i}`">
        <v-card flat>
          <v-card-text>
            {{ i }}
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items> -->

    <v-card>
      <v-tabs v-model="tab" background-color="blue darken-2" centered dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Total
        </v-tab>
        <v-tab href="#tab-2">
          Mkt
        </v-tab>
        <v-tab href="#tab-3">
          Cobranza
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1" :value="'tab-1'" :eager="true">
          <v-card flat>
            <v-card-text>              
              <div><AAsignacionTablaS ref="asignacionestablas" v-on:dataloaded="dataloaded" /></div>
              <p class="text-center text-danger">
                <b>{{ msg }}</b>
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2" :value="'tab-2'" :eager="true">
          <v-card flat>
            <v-card-text>
              <div><AAsignacionTablaMktSede ref="asignacionestablamkts" v-on:dataloaded="dataloaded" /></div>
              <p class="text-center text-danger">
                <b>{{ msg }}</b>
              </p>
            </v-card-text>

          </v-card>
        </v-tab-item>
        <v-tab-item :key="3" :value="'tab-3'" :eager="true" >
          <v-card flat>
            <v-card-text>
            cobranza
            <div><AAsignacionTablaCobranzaSede ref="asignacionestablacobranzas" v-on:dataloaded="dataloaded" /></div>
              <p class="text-center text-danger">
                <b>{{ msg }}</b>
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    
  </div>
</template>

<script>
  import AAsignacionTablaS from '@/components/AAsignacionSedeV2.vue';
  import AAsignacionTablaMktSede from '@/components/AAsignacionSedeMktV3N.vue';
  import AAsignacionTablaCobranzaSede from '@/components/AAsignacionSedeCobranzaV3N.vue'
  // import AAsignacionTablaMktS from '@/components/AAsignacionSedeMktV34.vue';
  // import AAsignacionTablaCobranzaS from '@/components/AAsignacionSedeCobranzaV3.vue';

  export default {
    data() {
      return {
        tab: null,
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        tiposasignacion: [
          { id: 1, text: 'Asignacion' },
          { id: 2, text: 'Inscritos' },
        ],
        loadinggestion: false,
        loadingmes: false,
        filtros: {
          gestion: null,
          mes: null,
          tipoasignacion: null,
        },
        buscar: '',
        datos: [],
        loading: false,
        msg: '',
        omit_filtro: false,

        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu2: false,
        xcuota: 1,
        only_cuota: true,
        xname: '',
        tabmodel: '',
      };
    },
    watch: {
      '$store.state.CARGO.sede': function() {
        this.resetcache();
        this.obtenerasignaciones();
      },
      '$store.state.convenio': function() {
        if (this.$store.state.convenio) {
          this.obtenerasignaciones();
        }
      },
      date: function() {
        this.validarNoFechaFutura();
      },
    },
    components: { 
      AAsignacionTablaS,
      AAsignacionTablaMktSede, 
      AAsignacionTablaCobranzaSede,
      // AAsignacionTablaCobranzaS
     },
    methods: {
      dataloaded() {
        this.loading = false;
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.tipoasignacion = this.tiposasignacion[0];
        this.filtros.gestion = '' + anio;
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      resetcache() {
        //this.$refs.asignacionestablas.resetcache();
      },
      validarNoFechaFutura() {
        let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        date.setHours(23);
        date.setMinutes(59);

        let date2 = new Date(this.date);
        date2.setHours(date2.getHours() + 4);

        let mayor = date2.getTime() > date.getTime();
        if (mayor) {
          let vue = this;
          let hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
          const [year, month, day] = hoy.split('-');
          let txt = `${year}-${month}-${day}`;
          this.$root.$notify.show(`Fechas futuras no estan permitidas.`, { color: 'red' });
          setTimeout(() => {
            vue.date = txt;
          }, 500);
        }
      },
      obtenerasignaciones() {
        if (!this.filtros.gestion) return;
        if (!this.filtros.mes) return;
        if (this.loading) return;
        this.loading = true;
        this.xname = '';
        let convenio = 0;
        let sede_id = this.$store.state.CARGO.sede.id;
        let idsede = this.$route.query.idsede;
        if (idsede) {
          sede_id = idsede;
          this.xname = this.$route.query.name;
        }
        if (this.$store.state.convenio && !this.omit_filtro) convenio = this.$store.state.convenio.id;

       this.$refs.asignacionestablas.obtenerasignaciones(sede_id, convenio, this.xcuota, this.date, this.only_cuota);
        window.console.log("obtenerasignaciones mkts");        
        this.$refs.asignacionestablamkts.obtenerasignaciones(sede_id, convenio, this.xcuota, this.date, this.only_cuota);
        window.console.log("obtenerasignaciones mkts");        
        this.$refs.asignacionestablacobranzas.obtenerasignaciones(sede_id, convenio, this.xcuota, this.date, this.only_cuota);
        //this.$refs.asignaciontablaMkts.obtenerasignaciones(sede_id, convenio, this.xcuota, this.date, this.only_cuota);
        //window.console.log("obtenerasignaciones cobrnza");
        //this.$refs.asignacionTablaCobranzas.obtenerasignaciones(sede_id, convenio, this.xcuota, this.date, this.only_cuota);
      },
    },
    mounted() {
      this.xname = '';
      this.defaultdata();
      let idsede = this.$route.query.idsede;
      if (idsede) {
        this.obtenerasignaciones();
      }
    },
  };
</script>
